<div class="template-editor-container">
    <h2 mat-dialog-title>Editar Template de Contrato</h2>
    <mat-dialog-content>
        <div *ngIf="loading" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Carregando template...</p>
        </div>

        <div *ngIf="!loading" class="editor-content">
            <div *ngIf="!previewMode" class="editor-mode">
                <div class="variables-panel">
                    <h3>Variáveis Disponíveis</h3>
                    <p class="help-text">Clique em uma variável para inseri-la
                        no ponto do cursor</p>
                    <div class="variables-list">
                        <button mat-stroked-button
                            *ngFor="let variable of availableVariables"
                            (click)="insertVariable(variable.name)"
                            matTooltip="{{ variable.description }}"
                            class="variable-btn">
                            {{ variable.name }}
                        </button>
                    </div>
                </div>

                <div class="template-form">
                    <form [formGroup]="form">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Conteúdo do Template</mat-label>
                            <textarea matInput
                                formControlName="templateContent"
                                rows="20"
                                placeholder="Digite o conteúdo HTML do template aqui..."></textarea>
                            <mat-error
                                *ngIf="form.get('templateContent')?.hasError('required')">
                                O conteúdo do template é obrigatório
                            </mat-error>
                        </mat-form-field>
                    </form>
                </div>
            </div>

            <div *ngIf="previewMode" class="preview-mode">
                <div class="preview-container">
                    <h3>Pré-visualização do Template</h3>
                    <div class="preview-content">
                        <div class="preview-html"
                            [innerHTML]="previewHtml"></div>
                    </div>
                    <p class="preview-note">Esta é uma prévia com dados de
                        exemplo. O resultado final pode variar.</p>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <div class="action-buttons">
            <button mat-stroked-button
                type="button"
                (click)="togglePreview()"
                [disabled]="loading || form.invalid">
                <mat-icon>{{ previewMode ? 'edit' : 'visibility' }}</mat-icon>
                {{ previewMode ? 'Voltar para Edição' : 'Pré-visualizar' }}
            </button>
            <button mat-stroked-button color="warn" (click)="cancel()"
                [disabled]="loading">
                <mat-icon>cancel</mat-icon>
                Cancelar
            </button>
            <button mat-raised-button
                color="primary"
                (click)="save()"
                [disabled]="loading || form.invalid">
                <mat-icon>save</mat-icon>
                <span *ngIf="!loading">Salvar</span>
                <span *ngIf="loading">Salvando...</span>
            </button>
        </div>
    </mat-dialog-actions>
</div>